import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    email: "",
    password: "",
    full_name: "",
    agency_name: "",
  });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Account creato");
      navigate("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Errore in registrazione");
    } finally {
      setLoading(false);
    }
  };

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-[#F9F8F6]">
      <div className="w-full max-w-lg fade-up">
        <div className="label-mono">Nuova agenzia</div>
        <h2 className="font-display text-4xl mt-2 font-light">Apri lo studio.</h2>
        <p className="text-sm text-[#5C5B5A] mt-3">
          Crea l&apos;account che gestirà la tua segreteria virtuale.
        </p>

        <form onSubmit={submit} className="mt-10 space-y-5">
          <div>
            <Label className="label-mono">Nome agenzia</Label>
            <Input
              required
              data-testid="register-agency-input"
              value={form.agency_name}
              onChange={upd("agency_name")}
              placeholder="Immobiliare Bianchi"
              className="mt-2 border-[#E5E4E0] bg-transparent focus:border-[#2C4C3B] focus:ring-0"
            />
          </div>
          <div>
            <Label className="label-mono">Il tuo nome</Label>
            <Input
              data-testid="register-fullname-input"
              value={form.full_name}
              onChange={upd("full_name")}
              placeholder="Mario Bianchi"
              className="mt-2 border-[#E5E4E0] bg-transparent focus:border-[#2C4C3B] focus:ring-0"
            />
          </div>
          <div>
            <Label className="label-mono">Email</Label>
            <Input
              required
              type="email"
              data-testid="register-email-input"
              value={form.email}
              onChange={upd("email")}
              placeholder="titolare@agenzia.it"
              className="mt-2 border-[#E5E4E0] bg-transparent focus:border-[#2C4C3B] focus:ring-0"
            />
          </div>
          <div>
            <Label className="label-mono">Password (min. 6)</Label>
            <Input
              required
              type="password"
              minLength={6}
              data-testid="register-password-input"
              value={form.password}
              onChange={upd("password")}
              className="mt-2 border-[#E5E4E0] bg-transparent focus:border-[#2C4C3B] focus:ring-0"
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            data-testid="register-submit-button"
            className="w-full bg-[#2C4C3B] hover:bg-[#1E3629] text-white font-mono uppercase tracking-[0.2em] text-xs py-6"
          >
            {loading ? "Creazione…" : "Crea account"}
          </Button>
        </form>

        <p className="text-sm text-[#5C5B5A] mt-8">
          Hai già un account?{" "}
          <Link to="/login" data-testid="goto-login-link" className="text-[#2C4C3B] underline underline-offset-4">
            Accedi
          </Link>
        </p>
      </div>
    </div>
  );
}
